import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'dashboard.referral.title',
    defaultMessage: 'Know a doctor who would like Sijilo?'
  },
  description: {
    id: 'dashboard.referral.description',
    defaultMessage:
      'Refer a fellow doctor and get {days} extra days added to your plan once we confirm they have joined.'
  },
  cta: {
    id: 'dashboard.referral.cta',
    defaultMessage: 'Refer a colleague'
  }
})
